import React from 'react'
import { getFirstLevelCategories } from 'lib/core/resources/helpers'
import { useCategoryList } from 'lib/modules/catalog'
import { NavItem } from './components/NavItem'
import { Container } from './styled'

export const MobileCategoryTree = () => {
  const categoryList = useCategoryList()
  const items = categoryList.list.filter(getFirstLevelCategories)

  return (
    <Container>
      <ul>
        {items.map((category) => {
          return (
            <NavItem
              key={category.id}
              category={category}
              categoryList={categoryList}
            />
          )
        })}
      </ul>
    </Container>
  )
}
